import React from "react";

export default function ListFetchError({
  message = "Unable to load products. Please try again.",
  onRetry,
  isLoading = false,
  className = "",
}) {
  return (
    <div
      className={`flex flex-col items-start gap-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${className}`.trim()}
      role="alert"
    >
      <p className="text-[16px] text-red-700 whitespace-pre-line">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          disabled={isLoading}
          className="shrink-0 rounded-full border border-red-300 bg-white px-4 py-2 text-[14px] font-semibold text-red-700 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isLoading ? "Retrying…" : "Try again"}
        </button>
      )}
    </div>
  );
}
